import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Button from "@common/Button";
import StyledInput from "@common/StyledInput";
import {
  GetWebUserDetails,
  getWebUserSelector,
} from "@slices/UserAccount/getWebUserDetails";
import { userSelector } from "@slices/UserAccount/userSlice";
import { useSelector, useDispatch } from "react-redux";
import { SendMailEnquiry } from "../../../redux/Slices/UserAccount/sendEmail";
import LoginPage from "../../pages/UserAccount/LoginPage";
import { defaultCustomerActions } from "@slices/UserAccount/defaultCustomer";
import { useTranslation } from "react-i18next";
import {
  fetchgetAllMenuDataForEmail,
  getAllMenuMailDataSelector,
} from "@slices/getAllMenuMail";
import { GetAllCountries } from "@slices/UserAccount/getAllCountries";
import { GetLocaleList } from "@slices/UserAccount/getLocaleList";
import { Mail } from "@icons";
import AnonymousLogin from "./AnonymousLogin";
import Modal from "@common/Modal";

interface IScreenStatus {
  login: boolean;
  forgotPasword: boolean;
  createAccount: boolean;
  forcePassword: boolean;
  default: boolean;
}

function MenuEmail() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [subject, setSubject] = useState("");
  const bodyMessage = t("CON_MESSAGES_EMAIL");
  const [body, setbody] = useState(bodyMessage);
  const userInfo = useSelector(userSelector)?.user?.user?.data;
  const [isOpen, setIsOpen] = useState(false);
  const isForceCustomer = userInfo?.isForceSelectCustomer;
  const getAllMenuDataMail = useSelector(
    getAllMenuMailDataSelector
  ).getAllMenuMailData;
  const webUserData = useSelector(getWebUserSelector)?.webUser;
  useState<boolean>(true);
  const senderEmailAddress = t("CON_SENDER_EMAIL_ADDRESS");
  const [email, setEmail] = useState(senderEmailAddress);
  const [subjectPlaceholder, setsubjectPlaceholder] = useState(
    t("MSG_USER_ALREADY_EXIST")
  );
  const [error, setError] = useState("");
  const [isInvalid, setIsinvalid] = useState(true);
  const isForcePassword = userInfo?.isForcePasswordChange;
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  const [screenStatus, setScreenStatus] = useState<IScreenStatus>({
    login: false,
    forgotPasword: false,
    createAccount: false,
    forcePassword: false,
    default: true,
  });

  useEffect(() => {
    setbody(t("CON_MESSAGES_EMAIL"));
    setEmail(t("CON_SENDER_EMAIL_ADDRESS"));
  }, [i18n.language]);

  const launchCreateAccountScreen = (show: boolean): void => {
    setScreenStatus((prevState: IScreenStatus) => {
      const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
      copiedState["login"] = false;
      copiedState["createAccount"] = show;
      copiedState["default"] = false;
      return copiedState;
    });
    dispatch(GetAllCountries());
    dispatch(GetLocaleList());
  };

  const forcePasswordChanged = (): void => {
    setScreenStatus((prevState: IScreenStatus) => {
      const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
      copiedState["login"] = true;
      copiedState["forcePassword"] = false;
      return copiedState;
    });
  };

  const navigateToSignInPage = (show: boolean): void => {
    setScreenStatus((prevState: IScreenStatus) => {
      const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
      copiedState["login"] = show;
      copiedState["createAccount"] = false;
      copiedState["default"] = false;
      return copiedState;
    });
  };

  useEffect(() => {
    if (isForcePassword) {
      setScreenStatus((prevState: IScreenStatus) => {
        const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
        copiedState["login"] = false;
        copiedState["forcePassword"] = true;
        return copiedState;
      });
    }
  }, [isForcePassword]);

  useEffect(() => {
    if (userInfo?.isAuthenticated) {
      if (!isForceCustomer) {
        dispatch(defaultCustomerActions.setSelected(true));
        handleClose();
      } else {
        setScreenStatus((prevState: IScreenStatus) => {
          const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
          copiedState["login"] = false;
          copiedState["default"] = false;
          return copiedState;
        });
      }
    }
  }, [userInfo?.isAuthenticated]);

  useEffect(() => {
    dispatch(fetchgetAllMenuDataForEmail());
  }, []);

  useEffect(() => {
    dispatch(GetWebUserDetails(userInfo?.sessionId));
  }, [userInfo?.isAuthenticated]);

  useEffect(() => {
    if (webUserData?.userEmail) {
      setEmail(webUserData?.userEmail);
    }
  }, [webUserData]);

  const handleClose = () => {
    if (!userInfo?.isAuthenticated && !screenStatus["createAccount"]) {
      setScreenStatus((prevState: IScreenStatus) => {
        const copiedState = { ...prevState }; //Copying old state to avoid mutating the original state
        copiedState["login"] = false;
        copiedState["default"] = true;
        copiedState["forcePassword"] = false;
        copiedState["forgotPasword"] = false;
        return copiedState;
      });
    }
  };
  const sendEmail = () => {
    dispatch(
      SendMailEnquiry(email, "", subject, body, "null", "", true, true, false)
    );
    setIsOpen(false);
    setbody(bodyMessage);
    !userInfo?.isAuthenticated
      ? setEmail(senderEmailAddress)
      : setEmail(webUserData?.userEmail);

    setSubject("");
    setIsinvalid(true);
  };

  const onClick = () => {
    setIsOpen(true);
    setbody(t("CON_MESSAGES_EMAIL"));
    setEmail(t("CON_SENDER_EMAIL_ADDRESS"));
    if (userInfo?.isAuthenticated) {
      setEmail(webUserData?.userEmail);
      if (!emailRegex.test(email)) {
        setError(t("CON_INVALID_EMAIL_ADDRESS"));
      } else {
        setError("");
      }
    }
  };

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.id === "mail") {
      setEmail(e.target.value);
      if (!emailRegex.test(e.target.value)) {
        setError(t("CON_INVALID_EMAIL_ADDRESS"));
      } else {
        setError("");
      }
    }

    if (e.target.id === "subject") {
      setSubject(e.target.value);
      if (e.target.value === "") {
        setIsinvalid(true);
      } else {
        setIsinvalid(false);
      }
    }
    if (e.target.id === "body") {
      setbody(e.target.value);
    }
  }

  const menuStatus = getAllMenuDataMail?.find(
    (obj: any) => obj.name == "CON_GENERAL_ENQUIRY"
  );
  const isMail = menuStatus?.signonRequired;

  return (
    <div style={{ overflow: "auto" }}>
      <div onClick={() => onClick()} style={{ cursor: "pointer" }}>
        <Mail className="icon-lg secondary-icon-2" />
      </div>

      <Modal
        isAlert
        title={""}
        isOpen={isOpen}
        hasCancelButton={false}
        hasSecondaryButton={false}
        onRequestClose={() => {
          setIsOpen(false);
        }}
      >
        {!isMail || userInfo?.isAuthenticated ? (
          <div className="mail-container">
            <MailSection className="custom-section">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="row ">
                        <div className="col-lg-12">
                          <BoldText style={{ paddingTop: "15px" }}>
                            <h3>{t("CON_COMPOSE_EMAIL")}</h3>
                          </BoldText>
                          {error ? (
                            <p style={{ color: "red" }}>{error}</p>
                          ) : null}
                        </div>
                      </div>
                      <hr
                        style={{
                          marginTop: "5px",
                          marginLeft: "-20px",
                          marginRight: "-20px",
                        }}
                      />
                      <div className="row ">
                        <div className="col-lg-12" style={{ marginTop: "5px" }}>
                          <EditText>
                            <h4>{t("CON_EMAIL")}</h4>
                          </EditText>
                          <StyledInput
                            onChange={handleChange}
                            id="mail"
                            type="text"
                            value={email}
                            validationErrorText="Please enter valid e-mail"
                            isInvalid={false}
                            style={{ maxWidth: "500px", marginTop: "5px" }}
                          />
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-lg-12">
                          <EditText>
                            <h4>{t("CON_SUBJECT")}</h4>
                          </EditText>
                          <StyledInput
                            onChange={handleChange}
                            id="subject"
                            type="text"
                            validationErrorText={t(
                              "MSG_MAIL_SUBJECT_MUST_BE_ENTERED"
                            )}
                            isInvalid={isInvalid}
                            placeholder={t("CON_SUBJECT_PLACEHOLDER")}
                            style={{ maxWidth: "500px", marginTop: "5px" }}
                          />
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-lg-12">
                          <StyledInput
                            onChange={handleChange}
                            id="body"
                            type="textarea"
                            value={body}
                            style={{
                              alignContent: "top",
                              maxWidth: "500px",
                              marginTop: "5px",
                              height: "100px",
                              wordWrap: "normal",
                            }}
                          />
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-lg-12">
                          <Button
                            className="float-right"
                            disabled={
                              subject.length === 0 ||
                              email.length === 0 ||
                              body.length === 0
                            }
                            type="submit"
                            variant="solid"
                            onClick={() => sendEmail()}
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                              justifyItems: "center",
                              marginTop: "10px",
                              width: "auto",
                              background: "var(--primary-icon-1)",
                            }}
                          >
                            <span>{t("CON_SEND_EMAIL")} </span>
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MailSection>
          </div>
        ) : (
          <div>
            {screenStatus["default"] && (
              <AnonymousLogin
                navigateToSignInPage={navigateToSignInPage}
                launchCreateAccountScreen={launchCreateAccountScreen}
              />
            )}

            {screenStatus["login"] && (
              <LoginPage
                launchCreateAccountScreen={launchCreateAccountScreen}
                fromSplash={true}
              />
            )}

            {/* {screenStatus["forcePassword"] && (
              <ForcePasswordChange
                forcePasswordChanged={forcePasswordChanged}
              />
            )}

            {screenStatus["createAccount"] && (
              <CreateAccount navigateToSignInPage={navigateToSignInPage} />
            )} */}
          </div>
        )}
      </Modal>
    </div>
  );
}

const MailSection = styled.section`
  display: flex;
  flex-direction: column;
  padding: 0px;
  flex-grow: 1;
  > :not(:last-child) {
    margin-bottom: 14px;
  }
`;
const BoldText = styled.text`
  font-weight: var(--font-weight-bold);
`;
const MediumText = styled.text`
  font-weight: var(--font-weight-medium);
`;

const EditText = styled.text`
  font-weight: var(--font-weight-medium);
  text-transform: capitalize;
  color: var(--input-text-color);
  line-height: 21.79px;
`;
const TextStyleLight = styled.section`
  font-weight: var(--font-weight-normal);
  color: var(--primary-color-3);
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default MenuEmail;
